import Layout from "../../common/layout/Layout";
import "./Review.scss";

export default function Posts() {
  return <Layout title={"Review"}>Review children</Layout>;
}
